// actions 
export default {
    "id": 1174,
    "deviceId": "17744cb7-9dcf-4be2-a3d7-304f424d3b31",
    "action": "hands_up",
    "frame": "4",
    "frame_id": "undefined17744cb7-9dcf-4be2-a3d7-304f424d3b31",
    "tracker_id": "1694704062343_3hWMd",
    "unix_itme_stamp": "1694704065677",
    "gifevidence": "/opt/alice-media/action_/17744cb7-9dcf-4be2-a3d7-304f424d3b31/2023/09/14/10/1694704065677/action_1694704065677_17744cb7-9dcf-4be2-a3d7-304f424d3b31.gif",
    "createdAt": "2023-09-14T15:07:46.781Z",
    "updatedAt": "2023-09-14T15:07:46.781Z"
}